export { default } from "ember-stereo/helpers/toggle-stereo-mute";
